<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="font-weight-bold text-primary">Add Product/Unit</h4>
                                </div>
                            </div>
                        </div>
                <div class="card-body p-5">
                    <form @submit.prevent="addProduct" autocomplete="off">
                <vue-good-wizard
                        :steps="steps"
                        :onNext="nextClicked"
                        :onBack="backClicked">

                    <div slot="page1">
                        <h4>Add Product details</h4>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label><b>Select Category</b></label>
                                            <v-select v-model="form.category" label="name" :options="categories"
                                                      :reduce="category => category.id" placeholder="Select Category"
                                                      @input="getSubCategories"></v-select>
                                            <small style="color: red" v-if="error && errors.category">{{ errors.category[0]}}</small>
                                            <small style="color: red" v-if="errn && errnv.category">{{ errnv.category}}</small>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label><b>Select Sub-Category</b></label>
                                            <v-select v-model="form.subcategory" label="name" :options="subcategories"
                                                      :reduce="sub => sub.id" placeholder="Select Sub-Category"
                                                      @input="getBrands"></v-select>
                                            <small style="color: red" v-if="error && errors.subcategory">{{ errors.subcategory[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.subcategory">{{ errnv.subcategory}}</small>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label><b>Select Brand</b></label>
                                            <v-select v-model="form.brand" label="name" :options="brands"
                                                      :reduce="brand => brand.id" placeholder="Select Brand"></v-select>
                                            <small style="color: red" v-if="error && errors.brand">{{ errors.brand[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.brand">{{ errnv.brand}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label><b>Title</b></label>
                                            <input v-model="form.title" type="text" name="title" placeholder="Title" class="form-control">
                                            <small style="color: red" v-if="error && errors.title">{{ errors.title[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.title">{{ errnv.title}}</small>

                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label><b>Price</b></label>
                                            <input v-model="form.price" type="number" name="price" placeholder="price" class="form-control">
                                            <small style="color: red" v-if="error && errors.price">{{ errors.price[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.price">{{ errnv.price}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label><b>Quantity/Size (Optional)</b></label>
                                            <input v-model="form.quantity" type="text" name="quantity" placeholder="Quantity/Size"
                                                   class="form-control">
                                            <small style="color: red" v-if="error && errors.quantity">{{ errors.quantity[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.quantity">{{ errnv.quantity}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Description</label>
                                            <vue-editor v-model="form.description"
                                                        :editorToolbar="myToolbar"></vue-editor>
                                            <small style="color: red" v-if="error && errors.description">{{ errors.description[0] }}</small>
                                            <small style="color: red" v-if="errn && errnv.description">{{ errnv.description}}</small>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    <div slot="page2">
                        <h4>Upload Images</h4>
                        <div class="form-group">
                            <label>Upload Images</label>
                            <VueFileAgent
                                    :accept="'image/*'"
                                    :multiple="true"
                                    :deletable="true"
                                    :maxSize="'10MB'"
                                    :maxFiles="14"
                                    v-model="attachments"
                                    @select="filesSelected($event)"
                                    @delete="fileDeleted($event)"></VueFileAgent>
                            <small style="color: red" v-if="error && errors.files">{{ errors.files[0] }}</small>
                            <small style="color: red" v-if="errn && errnv.files">{{ errnv.files}}</small>
                        </div>
                        <hr>
                    </div>
                </vue-good-wizard>
                    </form>
                </div>
            </div>
                </div>
            </div>
    </div>
    </div>
</template>
<script>

    import {VueEditor} from "vue2-editor";
    export default {
    name: 'addProducts',
    components: {
        VueEditor,

    },
      data() {
          return {
              steps: [
                  {
                      label: 'Add Item details',
                      slot: 'page1',
                  },
                  {
                      label: 'Upload Images',
                      slot: 'page2',
                  },
              ],
              fd: new FormData(),
              filesDataForUpload: [],
              attachments: [],
              myToolbar: [["bold", "italic"], [{list: "ordered"}, {list: "bullet"}]],
              errors: {},
              error: false,
              errn: false,
              errnv:{},
              isLoading: false,
              fullPage: true,
              brands: [],
              categories: [],
              shops:[],
              subcategories: [],
              form: {
                  shop:'',
                  brand: '',
                  category: '',
                  subcategory: '',
                  title: '',
                  price: '',
                  description: '',
                  quantity: ''
              }
          }
      },
      methods: {
          nextClicked(currentPage) {
              if (currentPage == 0){
                  if (!this.form.category) {
                      this.errn = true;
                      this.errnv.category = 'This field is required!';
                      return false;
                  }else if(!this.form.subcategory){
                      this.errn = true;
                      this.errnv.subcategory = 'This field is required!';
                      return false;
                  }else if(!this.form.brand){
                      this.errn = true;
                      this.errnv.brand = 'This field is required!';
                      return false;
                  }else if(!this.form.title){
                      this.errn = true;
                      this.errnv.title = 'This field is required!';
                      return false;
                  }else if(!this.form.price){
                      this.errn = true;
                      this.errnv.price = 'This field is required!';
                      return false;
                  }else if(!this.form.description){
                      this.errn = true;
                      this.errnv.description = 'This field is required!';
                      return false;
                  }else{
                      this.errn = false;
                      this.errnv.category = '';
                      this.errnv.subcategory = '';
                      this.errnv.brand = '';
                      this.errnv.title = '';
                      this.errnv.price = '';
                      this.errnv.quantity = '';
                      this.errnv.description = '';
                      return true;
                  }
              }else if (currentPage == 1){
                 if (!this.filesDataForUpload.length){
                      this.errn = true;
                      this.errnv.files = 'This field is required!';
                      return false;
                  }
                  this.errn = false;
                  this.errnv.files = '';
                  this.addProduct();
                  return true;

              }

          },
          backClicked() {
              return true; //return false if you want to prevent moving to previous
          },
          addProduct(){
              this.isLoading = true;
              for (let i = 0; i < this.filesDataForUpload.length; i++) {
                  this.fd.append('files[]', this.filesDataForUpload[i].file);
              }
              this.fd.append('brand', this.form.brand);
              this.fd.append('category', this.form.category);
              this.fd.append('subcategory', this.form.subcategory);
              this.fd.append('title', this.form.title);
              this.fd.append('price', this.form.price);
              this.fd.append('description', this.form.description);
              this.fd.append('quantity', this.form.quantity);

              const config = {headers: {'Content-Type': 'multipart/form-data'}};
              this.axios.post('/retailer/dashboard/products', this.fd, config).then(()=> {
                  this.isLoading = false;
                  this.$swal.fire({
                      icon: 'success',
                      title: 'Success!!',
                      text: 'Product added Successfully',
                  })
                  this.$router.go();

              })
                  .catch(error => {
                      this.isLoading = false;
                      this.error = true;
                      this.errors = error.response.data.errors;
                  });
          },
          fileDeleted: function(fileData) {
              var i = this.filesDataForUpload.indexOf(fileData);
              if (i !== -1) {
                  this.filesDataForUpload.splice(i, 1);
              } else {
                  this.deleteUploadedFile(fileData);
              }
          },
          filesSelected: function(filesDataNewlySelected) {
              var validFilesData = filesDataNewlySelected.filter((fileData) => !fileData.error);
              this.filesDataForUpload = this.filesDataForUpload.concat(validFilesData);
          },
          getSubCategories() {
              this.form.subcategory = '';
              this.form.brand = '';
              this.axios.get("/retailer/dashboard/sub-category/" + this.form.category).then(({data}) => ([this.subcategories = data]));
          },
          getCategories() {
              this.axios.get("/retailer/dashboard/category").then(({data}) => ([this.categories = data]));
          },
          getBrands() {
              this.form.brand = '';
              this.axios.get("/retailer/dashboard/my-brands/" + this.form.subcategory).then(({data}) => ([this.brands = data]));
          },

      },
      created() {
          this.getCategories();
      }

  };
</script>
<style></style>
